import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import "../App.css";

export default function LegalPage({ bodyKey }) {
  const { t } = useTranslation();

  useEffect(() => {
    document.documentElement.style.backgroundColor = "#131313";
    document.body.style.backgroundColor = "#131313";
    return () => {
      document.documentElement.style.backgroundColor = "";
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <div
      className="App scrollable-page legal-page"
      style={{ backgroundColor: "#131313", color: "white" }}
    >
      <article>
        <ReactMarkdown
          components={{
            ul: ({ node, ...props }) => (
              <ul
                style={{ listStyleType: "square", fontSize: "1.2rem" }}
                {...props}
              />
            ),
            a: ({ node, ...props }) => (
              <a style={{ color: "white" }} {...props} />
            ),
          }}
        >
          {t(bodyKey)}
        </ReactMarkdown>
      </article>
    </div>
  );
}
